import {
  CSSObject,
  Theme,
  getFontWeight,
  forBrands,
} from '@core-ui/react-stitch';

export const getFullHexColor = (hex: string, transparency?: string) => {
  const fullHexColor = hex.length < 5 ? hex + hex.substring(1) : hex;
  return transparency ? fullHexColor + transparency : fullHexColor;
};

const setBackgroundColorForBR = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
     isBRcolor2023FFEnabled ? "#F6F4EB":theme.color.inverse.b1

const setOptionStyleForBananaRepublic = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  color: isBRcolor2023FFEnabled ? "#000000" : theme.color.b2,
  backgroundColor: setBackgroundColorForBR(theme,isBRcolor2023FFEnabled),
  fontWeight: getFontWeight('regular').fontWeight,
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: theme.color.wh,
  },
  '&[aria-selected="true"]': {
    backgroundColor: getFullHexColor(isBRcolor2023FFEnabled ? "#000000" : theme.color.b1, '1A'),
  },
});

const getOptionStyles =
  (isBRcolor2023FFEnabled:boolean) =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...(forBrands(theme, {
      br: setOptionStyleForBananaRepublic(theme,isBRcolor2023FFEnabled),
      brfs: setOptionStyleForBananaRepublic(theme,isBRcolor2023FFEnabled),
    }) as CSSObject),
  });

export default getOptionStyles;
